"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const video_client_core_1 = require("@video/video-client-core");
const mobx_1 = require("mobx");
const react_1 = require("react");
const fullscreen_1 = require("./fullscreen");
class UiState extends video_client_core_1.ObservableEventEmitter {
    constructor() {
        super();
        /**
         * The reference to the HTMLVideoElement.
         */
        this.videoElement = (0, react_1.createRef)();
        /**
         * Video Container wrapper element.
         *
         */
        this.videoWrapperElement = (0, react_1.createRef)();
        /**
         * Indicates whether application is fullscreen.
         */
        this.isFullscreen = false;
        /**
         * Indicates whether the application has been opened in a new window.
         */
        this.newWindow = null;
        /**
         * New window DOM element
         */
        this.newWindowElement = null;
        /**
         * Indicates whether the application has launched in a React portal.
         */
        this.portal = false;
        /**
         * React Portal DOM element
         */
        // portalElement: document.createElement('div');
        this.portalElement = null;
        /**
         * Indicates whether the encoder settings are visible.
         */
        this.viewSettings = false;
        /**
         * Indicates whether the call settings are visible.
         */
        this.viewVideoCallSlider = false;
        /**
         * Watches for mouse over on VideoWrapper
         */
        this.videoMouseOver = video_client_core_1.adapter.device.isMobileDevice;
        /**
         * Indicates if we are using a mobile device
         */
        this.mobileDevice = video_client_core_1.adapter.device.isMobileDevice;
        /**
         * Indicates if we are using a mobile device
         */
        this.iosDevice = video_client_core_1.adapter.device.isIosDevice;
        /**
         * Indicates if screenShare is supported
         */
        this.screenShareSupported = !video_client_core_1.adapter.device.isMobileDevice;
        /**
         * Indicates if screenShare is supported
         */
        this.volumeRangeSupported = !video_client_core_1.adapter.device.isIosDevice;
        (0, mobx_1.makeObservable)(this, {
            // observers
            videoWrapperElement: mobx_1.observable.ref,
            isFullscreen: mobx_1.observable,
            newWindow: mobx_1.observable,
            newWindowElement: mobx_1.observable.ref,
            portal: mobx_1.observable,
            portalElement: mobx_1.observable.ref,
            viewSettings: mobx_1.observable,
            viewVideoCallSlider: mobx_1.observable,
            videoMouseOver: mobx_1.observable,
            // actions
            toggleFullscreen: mobx_1.action,
            onFullscreenChange: mobx_1.action,
        });
        document.addEventListener("fullscreenchange", this.onFullscreenChange);
        document.addEventListener("webkitfullscreenchange", this.onFullscreenChange);
        this.addInnerDisposer(() => {
            document.removeEventListener("fullscreenchange", this.onFullscreenChange);
            document.removeEventListener("webkitfullscreenchange", this.onFullscreenChange);
        });
    }
    onFullscreenChange() {
        this.isFullscreen = (0, fullscreen_1.fullscreenElement)() != null;
    }
    /**
     * Toggle `isFullscreen`
     * @async
     * @description Toggles the encoder to/from fullscreen and sets uiState.isFullscreen
     * to true/false.
     * @returns Promise
     * @example <caption>Example usage of toggleFullscreen.</caption>
     * toggleFullscreen();
     * // Sets encoder to/from fullscreen and updates uiState.isFullscreen = true|false;
     */
    async toggleFullscreen() {
        if (this.videoWrapperElement.current == null) {
            return;
        }
        if (this.isFullscreen) {
            await (0, fullscreen_1.exitFullscreen)();
        }
        else {
            await (0, fullscreen_1.requestFullscreen)(this.videoWrapperElement.current);
        }
    }
}
exports.default = UiState;
//# sourceMappingURL=ui-state.js.map